export let digitalData={
  page:{
    pageInfo:{
      pageName:"Login Page", //s.pageName //ALL PAGES
    },
    error:[ //when applicable
      {errorMessage:""}//s.list1
    ],
	customAttributes: [],
  },
  site:{ //all pages
    siteName:"PCG-Express-Pay",//s.prop28
    language:"",//s.eVar33
    businessUnit:"",//s.prop29
    country:""//s.eVar31
  },
  user:{
    customerID: "",
    paymentType: "",
    scenario:{ //on scenario pages, scenario card selections
      filter:"",//s.eVar60
      card:[
        {selectedCard:""},//s.list2
        {selectedCard:""}//s.list2
      ]
    },
    profile:{ //optional, when known/applicable
      age:"",//s.eVar5
      gender:"",//s.eVar6
      address:{
        postalCode:""//s.eVar11
      },
      profileID:""//s.eVar21
    }
  }
};



// WEBPACK FOOTER //
// ./src/utils/analyticsData.js